module.exports = __webpack_public_path__ + "static/redwood-1058c924016177be9bb3089ed93dc702.jpg";